import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "clase-view" }
const _hoisted_2 = { class: "clase-left" }
const _hoisted_3 = { class: "clase-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PRO_Clase = _resolveComponent("PRO_Clase")!
  const _component_PRO_Categorii = _resolveComponent("PRO_Categorii")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PRO_Clase, { onSelectionChanged: $options.handleSelectionChanged }, null, 8, ["onSelectionChanged"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_PRO_Categorii, {
        ClasaID: $data.selectedRow,
        ClasaNume: $data.selectedNume
      }, null, 8, ["ClasaID", "ClasaNume"])
    ])
  ]))
}